import Vue from "vue";
const vm = Vue.prototype;

export const state = () => ({
  schools: [],
  school: {},

  schools_all: [],
});

export const mutations = {
  SET_SCHOOLS(state, payload) {
    state.schools = vm.$toArray(payload);
  },

  SET_SCHOOL_BY_ID(state, payload) {
    state.school = payload || {};
  },

  SET_SCHOOLS_ALL(state, payload) {
    state.schools_all = vm.$toArray(payload);
  },
};

export const actions = {
  async INIT_SCHOOLS({ commit }, options) {
    const { itemsPerPage, search = "", sortBy = [], sortDesc = [] } = options;

    const page = Number(options.page - 1) || 0;
    const sortField = sortBy.length ? sortBy[0] : "";
    const sortOrder = sortDesc.length && sortDesc[0] ? "desc" : "asc";

    const senc = search ? encodeURI(search) : null;

    const query = `?page=${page}&size=${itemsPerPage}&name=${senc}&sortField=${sortField}&sortOrder=${sortOrder}`;
    let totalItemsCount = 0;

    const data = await vm.$axios.$get(`admin/school${query}`);
    if (data) {
      commit("SET_SCHOOLS", data.content);

      totalItemsCount = data.totalElements;
    }

    return totalItemsCount;
  },

  async SCHOOL_BY_ID({ commit }, { id }) {
    let status = false;

    try {
      const data = await vm.$axios.$get(`admin/school/${id}`);
      if (Array.isArray(data)) {
        commit("SET_SCHOOL_BY_ID", data);

        status = true;
      }
    } catch (error) {
      //
    }

    return status;
  },

  async ADD_SCHOOL(ctx, school) {
    let status = false;
    const url = "admin/school";
    const method = school.id ? "$post" : "$put";

    status = await vm.$axios[method](url, school);

    return status;
  },

  async SCHOOL_STATUS(ctx, { id, active }) {
    let status = false;

    const url = `admin/school/${id}/`;
    const method = !active ? "deactivation" : "activation";

    status = await vm.$axios.$post(url + method);

    return status;
  },

  async INIT_SCHOOLS_ALL({ commit }) {
    const data = await vm.$axios.$get(`admin/school/all`);
    if (data) {
      commit("SET_SCHOOLS_ALL", data);
    }
  },
};

export const getters = {
  GET_SCHOOLS: (state) => state.schools,
  GET_SCHOOL_BY_ID: (state) => state.school,

  GET_SCHOOLS_ALL: (state) => state.schools_all,
};
